import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-title',
  template: `
    <h1 class="app-page-title text-gray-900 dark:text-gray-100" [attr.id]="headingId || null">
      {{ title }}
    </h1>
  `,
  styles: [
    `
      :host {
        display: block;
        min-width: 0;
      }

      .app-page-title {
        margin: 0;
        font-size: clamp(0.85rem, 3.5vw, 1.25rem);
        font-weight: 700;
        line-height: 1.2;
        word-break: keep-all; /* Não quebra palavras, mesmo que transbordem */
        overflow-wrap: normal; /* Volta ao comportamento padrão de não quebrar letras */
        white-space: normal; /* Permite quebra de linha apenas nos espaços */
        overflow: hidden;
        display: -webkit-box; /* Se ainda assim for grande demais, ele trunca com ... */
        -webkit-line-clamp: 2; /* Limita a no máximo 2 linhas antes de cortar */
        -webkit-box-orient: vertical;
      }
    `,
  ],
})
export class PageTitleComponent {
  @Input() title = '';
  @Input() headingId = '';
}
